(function () {
  "use strict";

  var VERSION = "shopify_attr_capture_t0_20260709";
  var STORAGE_FIRST = "vgos_attribution_first";
  var STORAGE_LAST = "vgos_attribution_last";
  var STORAGE_HASH = "vgos_attribution_cart_hash";
  var COOKIE_FIRST = "vgos_attr_first";
  var COOKIE_LAST = "vgos_attr_last";
  var RETENTION_DAYS = 30;
  var MAX_VALUE_LENGTH = 1024;

  var PARAM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_campaign_id",
    "utm_id",
    "utm_adset",
    "utm_adset_id",
    "utm_adgroup",
    "utm_adgroup_id",
    "utm_ad",
    "utm_ad_id",
    "utm_content",
    "campaign_id",
    "adset_id",
    "ad_id",
    "creative_id",
    "fbclid",
    "gclid",
    "wbraid",
    "gbraid",
    "ttclid"
  ];

  var ATTRIBUTE_FIELDS = [
    "captured_at",
    "landing_page",
    "referrer",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_campaign_id",
    "utm_adset",
    "utm_adset_id",
    "utm_ad",
    "utm_ad_id",
    "utm_content",
    "fbclid",
    "gclid",
    "wbraid",
    "gbraid",
    "ttclid"
  ];

  function nowIso() {
    return new Date().toISOString();
  }

  function truncate(value) {
    var text = String(value || "");
    if (text.length <= MAX_VALUE_LENGTH) return text;
    return text.slice(0, MAX_VALUE_LENGTH);
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(String(value || "").replace(/\+/g, " "));
    } catch (error) {
      return String(value || "");
    }
  }

  function getParam(searchParams, key) {
    var value = searchParams.get(key);
    if (value === null || value === undefined || value === "") return "";
    return truncate(safeDecode(value));
  }

  function sanitizedUrl(input) {
    if (!input) return "";
    try {
      var url = new URL(input, window.location.origin);
      var clean = new URL(url.origin + url.pathname);
      PARAM_KEYS.forEach(function (key) {
        var value = url.searchParams.get(key);
        if (value) clean.searchParams.set(key, truncate(safeDecode(value)));
      });
      return truncate(clean.toString());
    } catch (error) {
      return truncate(String(input || "").split("#")[0]);
    }
  }

  function readCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie ? document.cookie.split(";") : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try {
          return JSON.parse(decodeURIComponent(part.slice(prefix.length)));
        } catch (error) {
          return null;
        }
      }
    }
    return null;
  }

  function writeCookie(name, payload) {
    try {
      var expires = new Date(Date.now() + RETENTION_DAYS * 24 * 60 * 60 * 1000).toUTCString();
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = name + "=" + encodeURIComponent(JSON.stringify(payload)) + "; expires=" + expires + "; path=/; SameSite=Lax" + secure;
    } catch (error) {
      /* no-op */
    }
  }

  function readStorage(key, cookieName) {
    try {
      var raw = window.localStorage.getItem(key);
      if (raw) return JSON.parse(raw);
    } catch (error) {
      /* use cookie fallback */
    }
    return readCookie(cookieName);
  }

  function writeStorage(key, cookieName, payload) {
    try {
      window.localStorage.setItem(key, JSON.stringify(payload));
      return;
    } catch (error) {
      writeCookie(cookieName, payload);
    }
  }

  function hasAttributionParams(payload) {
    return PARAM_KEYS.some(function (key) {
      return Boolean(payload.raw[key]);
    });
  }

  function normalizePayload(raw) {
    return {
      captured_at: raw.captured_at || nowIso(),
      landing_page: raw.landing_page || "",
      referrer: raw.referrer || "",
      utm_source: raw.utm_source || "",
      utm_medium: raw.utm_medium || "",
      utm_campaign: raw.utm_campaign || "",
      utm_campaign_id: raw.utm_campaign_id || raw.utm_id || raw.campaign_id || "",
      utm_adset: raw.utm_adset || raw.utm_adgroup || "",
      utm_adset_id: raw.utm_adset_id || raw.utm_adgroup_id || raw.adset_id || "",
      utm_ad: raw.utm_ad || "",
      utm_ad_id: raw.utm_ad_id || raw.ad_id || "",
      utm_content: raw.utm_content || raw.creative_id || "",
      fbclid: raw.fbclid || "",
      gclid: raw.gclid || "",
      wbraid: raw.wbraid || "",
      gbraid: raw.gbraid || "",
      ttclid: raw.ttclid || "",
      status: raw.status || "captured",
      version: VERSION
    };
  }

  function captureCurrentTouch() {
    var url = new URL(window.location.href);
    var raw = {
      captured_at: nowIso(),
      landing_page: sanitizedUrl(window.location.href),
      referrer: sanitizedUrl(document.referrer || ""),
      status: "no_paid_params"
    };

    PARAM_KEYS.forEach(function (key) {
      raw[key] = getParam(url.searchParams, key);
      if (raw[key]) raw.status = "captured";
    });

    return {
      raw: raw,
      normalized: normalizePayload(raw),
      hasParams: hasAttributionParams({ raw: raw })
    };
  }

  function getAttributionState() {
    var current = captureCurrentTouch();
    var first = readStorage(STORAGE_FIRST, COOKIE_FIRST);
    var last = readStorage(STORAGE_LAST, COOKIE_LAST);

    if (!first) {
      first = current.normalized;
      writeStorage(STORAGE_FIRST, COOKIE_FIRST, first);
    }

    if (current.hasParams || !last) {
      last = current.normalized;
      writeStorage(STORAGE_LAST, COOKIE_LAST, last);
    }

    return {
      first: normalizePayload(first),
      last: normalizePayload(last)
    };
  }

  function setField(attributes, prefix, payload, field) {
    var value = payload[field];
    if (value !== undefined && value !== null && String(value) !== "") {
      attributes["vgos_" + prefix + "_" + field] = truncate(value);
    }
  }

  function buildCartAttributes(state) {
    var attributes = {
      vgos_capture_version: VERSION,
      vgos_capture_source: "theme_cart_attributes"
    };

    ATTRIBUTE_FIELDS.forEach(function (field) {
      setField(attributes, "first", state.first, field);
      setField(attributes, "last", state.last, field);
    });

    attributes.vgos_capture_status = state.last.status || state.first.status || "storage_only";
    return attributes;
  }

  function stableStringify(value) {
    var keys = Object.keys(value).sort();
    var output = {};
    keys.forEach(function (key) {
      output[key] = value[key];
    });
    return JSON.stringify(output);
  }

  function shouldSync(attributes) {
    var nextHash = stableStringify(attributes);
    try {
      var previousHash = window.localStorage.getItem(STORAGE_HASH);
      if (previousHash === nextHash) return false;
      window.localStorage.setItem(STORAGE_HASH, nextHash);
    } catch (error) {
      /* continue without hash cache */
    }
    return true;
  }

  function syncCartAttributes(options) {
    var state = getAttributionState();
    var attributes = buildCartAttributes(state);
    if (!shouldSync(attributes) && !(options && options.force)) return Promise.resolve({ skipped: true });

    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ attributes: attributes }),
      credentials: "same-origin",
      keepalive: Boolean(options && options.keepalive)
    }).catch(function () {
      return { failed: true };
    });
  }

  function looksLikeCheckoutClick(target) {
    if (!target || !target.closest) return false;
    return Boolean(target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], button[data-checkout], [data-checkout-button]'));
  }

  function boot() {
    getAttributionState();
    syncCartAttributes();

    document.addEventListener("click", function (event) {
      if (looksLikeCheckoutClick(event.target)) {
        syncCartAttributes({ force: true, keepalive: true });
      }
    }, true);

    window.VarlaAttributionCapture = {
      version: VERSION,
      getState: getAttributionState,
      buildCartAttributes: function () {
        return buildCartAttributes(getAttributionState());
      },
      syncCartAttributes: function () {
        return syncCartAttributes({ force: true });
      }
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
}());
